'use client';

import React from 'react';
import { cn } from '@/lib/utils';
import { useGradient, UseGradientOptions } from '@/lib/mesh-gradient';
import { QUIZ_GRADIENT_COLORS } from '../../constants';

export interface MeshGradientBackgroundProps
  extends Omit<UseGradientOptions, 'autoplay'> {
  /**
   * 追加のクラス名
   */
  className?: string;
  /**
   * 自動再生するかどうか
   * @default true
   */
  autoplay?: boolean;
}

/**
 * Stripe風のメッシュグラデーション背景コンポーネント
 * WebGLを使用してスムーズなアニメーショングラデーションを描画
 *
 * @example
 * ```tsx
 * <MeshGradientBackground
 *   colors={QUIZ_GRADIENT_COLORS}
 *   className="absolute inset-0"
 * />
 * ```
 */
export function MeshGradientBackground({
  className,
  autoplay = true,
  colors = QUIZ_GRADIENT_COLORS,
  ...gradientOptions
}: MeshGradientBackgroundProps) {
  const { canvasRef } = useGradient({
    autoplay,
    colors,
    ...gradientOptions,
  });

  return (
    <canvas
      ref={canvasRef}
      className={cn('pointer-events-none', className)}
      style={{
        width: '100%',
        height: '100%',
      }}
    />
  );
}
